import React from "react";
import { Typography, Link, Box, Container } from "@mui/material";
import SocialMediaBar from "./SocialMediaBar";

const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: 'background.paper', py: 6, borderTop: (theme) => `1px solid ${theme.palette.divider}` }}>
      <Container maxWidth="lg">
        <Box sx={{ mb: 4 }}>
          <SocialMediaBar />
        </Box>
        <Typography variant="body2" color="text.secondary" align="center">
          {"© "}
          MRuns LLC {new Date().getFullYear()}
          {"."}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
